<div class="status-page">
  <header class="page-header">
    <div class="logo-title">
      <img [src]="logoSrc" alt="Logo" class="logo" />
      <h1>API Status Page</h1>
    </div>
  </header>

  <div class="filter-container">
    <input
      type="text"
      placeholder="Filter by service name..."
      [ngModel]="filterQuery()"
      (ngModelChange)="filterQuery.set($event)"
      class="filter-input" />
  </div>

  <main class="services-container">
    <fin-api-status-card
      *ngFor="let service of filteredServices()"
      [name]="service.name"
      [status]="service.status"
      [description]="service.description"
      [dependencies]="service.dependencies"></fin-api-status-card>
  </main>

  <footer class="page-footer">
    <p>&copy; {{ currentYear }} Finverity. All rights reserved.</p>
  </footer>
</div>
